import React from 'react';

type InfoItemProps = {
  label: string;
  value: string;
}

const baseString = 'review-and-download';

export const InfoItem = ({ label, value }: InfoItemProps) => {
  return (
    <div className={`${baseString}__info-item`}>
      <label className={`${baseString}__info-label`}>{label}</label>
      <span className={`${baseString}__info-value`}>{value}</span>
    </div>
  );
};
